import React from 'react';
import { Typography } from "@material-ui/core";
import { Parallax } from 'react-scroll-parallax';
import AppearingElement from '../Helper/AppearingElement';
import './main.css';

// Landing Pages Section 2A
function MountainInfoSection(props) {
    const videoRef = React.useRef();

    React.useEffect(() => {
        muteVideo();
    });

    const muteVideo = () => {
        const video = videoRef.current;
        video.volume = 0;
        video.muted = true;
        video.play();
    }

    return (
        <section className="mountain-info-section-whatFix">
            <div className="mountain-info-section__content-whatFix">
                {!props.hideParallax &&
                    <Parallax y={[-20, 5]}>
                        <AppearingElement variant="fade-in">
                            <Typography variant="h6">
                                {props.content}
                            </Typography>
                        </AppearingElement>
                    </Parallax>
                }
                {props.hideParallax &&
                    <AppearingElement variant="zoom-down">
                        <Typography variant="h6">
                            {props.content}
                        </Typography>
                    </AppearingElement>
                }
            </div>
            {!props.hideParallax &&
                <Parallax y={[42.5, 12.5]} className="mountain-info-section__media-whatFix">
                    <AppearingElement variant="fade-in" threshold="0.2">
                        <video src={props.media} ref={videoRef} autoPlay loop muted playsInline>
                            Sorry, your browser doesn't support embedded videos.
                    </video>
                    </AppearingElement>
                </Parallax>
            }
            {props.hideParallax &&
                <video src={props.media} className="mountain-info-section__media-whatFix" ref={videoRef} autoPlay loop muted playsInline>
                    Sorry, your browser doesn't support embedded videos.
            </video>
            }
        </section>
    );
}

export default MountainInfoSection;